import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { stateMessages as messages } from './stateMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the live screens; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
import styles from './Live.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * No good fit yet (design t6): the find ended with no curator with an email who fits. Plug keeps
 * looking every night. `scanned` is the real playlist count of the last find, or null.
 */
const NoFitStateComponent: React.FC<{ song: string; scanned: number | null }> = ({ song, scanned }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  return (
    <section className={clsx(styles.card, styles.state)} data-testid="outreach-state-no-fit">
      <span className={shared.eyebrow}>{intl.formatMessage(messages.noFitEyebrow)}</span>
      <h2 className={styles.stateTitle}>{intl.formatMessage(messages.noFitTitle)}</h2>
      <p className={styles.stateBody}>{intl.formatMessage(messages.noFitBody, { song })}</p>
      {scanned !== null && (
        <div className={shared.row}>
          <span className={styles.spin} aria-hidden />
          <span className={shared.small}>{intl.formatMessage(messages.noFitLastCheck, { count: scanned })}</span>
        </div>
      )}
      <div className={styles.stateActions}>
        <SMLButton outline omitCap onClick={() => router.push(SMLRoutes.outreachProfile)}>
          {intl.formatMessage(messages.noFitAddGenres)}
        </SMLButton>
        <SMLButton outline omitCap onClick={() => router.push(SMLRoutes.outreachContacts)}>
          {intl.formatMessage(messages.noFitImport)}
        </SMLButton>
      </div>
    </section>
  );
};

export const NoFitState = TypedMemo(NoFitStateComponent);
